import React, {useState} from 'react';
import 'antd/dist/antd.css';
// import '../index.css';
import {Image, Typography} from 'antd';
import ImageUpload from './ImageUpload'
// import axios from "axios";
const {Title} = Typography;

const App: React.FC = () => {
    const [imageInput, setImageInput] = useState([]);
    const size = 368

    const setImages = (data) => {
        // console.log(data)
        setImageInput('data:image/png;base64,' + data)
        // setImageInput(data)

        // let utf8Encode = new TextEncoder();
        // let e = utf8Encode.encode(data);
        //
        // console.log(e)
        //
        // var utf8 = decodeURI(encodeURIComponent(data));
        //
        // var arr = [];
        // for (var i = 0; i < utf8.length; i++) {
        //     arr.push(utf8.charCodeAt(i));
        // }
        //
        // console.log(arr)
        //
        // let blob = new Blob([arr], {type: 'image/png'});
        // var reader = new FileReader();
        // reader.readAsDataURL(blob);
        // reader.onloadend = function () {
        //     var base64data = reader.result;
        //     console.log(base64data);
        //     setImageInput(base64data)
        // }
        //
        // console.log(blob)
        // console.log(URL.createObjectURL(blob))
    }


    return (
        <>
            <Title level={4}>Anime border detector</Title>
            <ImageUpload
                urlAPI={'https://arz.ai/pic2scratch'}
                // urlAPI={'http://127.0.0.1:8000/pic2scratch'}
                setResponse={setImages}
                name={'image'}
            />
            <Image
                width={size}
                src={imageInput}
            />
        </>
    );
};

export default App;